/* eslint-disable @typescript-eslint/no-explicit-any */
import { props, emptyProps, createActionGroup } from '@ngrx/store';

import { common } from '@qwyk/models';

export const CustomTagsActions = createActionGroup({
    source: 'Custom Tags/API',
    events: {
        Init: emptyProps(),
        'Tag Entity': props<{ data: Partial<common.CustomTag>[] }>(),
        'Tag Entity Success': props<{ data: Partial<common.CustomTag[]> }>(),
        'Tag Entity Failure': props<{ error: any }>(),
        'Search Tags': props<{ name: string }>(),
        'Search Tags Success': props<{ custom_tags: common.SearchCustomTag[]; }>(),
        'Search Tags Failure': props<{ error: any }>(),
        'Load Tags': props<{ query: any, isSuggestion: boolean }>(),
        'Load Tags Success': props<{ custom_tags: common.CustomTag[], pagination: common.PaginationMeta; isSuggestion: boolean }>(),
        'Load Tags Failure': props<{ error: any }>(),
        'Remove Tag': props<{ parent: string; request: common.CustomTag; }>(),
        'Remove Tag Success': props<{ custom_tag: common.CustomTag; }>(),
        'Remove Tag Failure': props<{ error: any }>(),
        'Link Tag to Entity': props<{ data: Partial<common.CustomTag>[], tagId: string }>(),
        'Link Tag to Entity Success': props<{ tag: common.CustomTag, entityId: string }>(),
        'Link Tag to Entity Failure': props<{ error: any }>(),
        'Unlink Tag from Entity': props<{ tagId: string, entityId: string, entity: string }>(),
        'Unlink Tag from Entity Success': props<{ tagId: string, entityId: string }>(),
        'Unlink Tag from Entity Failure': props<{ error: any }>(),
        'Update Tag': props<{ request: Partial<common.CustomTag>; }>(),
        'Update Tag Success': props<{ tag: common.CustomTag }>(),
        'Update Tag Failure': props<{ error: any }>(),
        'Backend Failure': props<{ error: any }>(),
        Reset: emptyProps(),
    },
});
